import * as yup from "yup";

export const userSchema = yup.object().shape({
   firstname: yup.string().required("First Name is required!"),
   lastname: yup.string().required("Last Name is required!"),
   email: yup.string().email().required("Email is required!"),
   domain: yup
      .string()
      .min(4)
      .required("Domain is required!")
      .matches(/^[a-zA-Z][a-zA-Z0-9]{3,}$/, "domain should be a basic url i.e metrick360"),
   password: yup
      .string()
      .required("Password is required")
      .matches(
         // /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d@#$!%*?^_()+=&]{8,}$/,
         /(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$#%~%^&*-]).{8,}/,
         "Atleast 8 characters including uppercase, lowercase and special characters."
      ),

   confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match")
      .required("Password confirm is required"),
   acceptTerms: yup
      .bool()
      .oneOf([true], "Please, Accept Terms and Conditions.")
      .required("Please, Accept Terms and Conditions."),
});

export const campaignStepOneSchema = yup.object().shape({
   campaign_name: yup.string().required("Please Give your campign a name"),
   campaign_type: yup.string().required("Please select campaign type"),
   url: yup.string().required("Affiliates need a landing page"),
   currency: yup.string().required("Please select your preferred currency!"),
   interval: yup.string(),
   trial_period: yup.number().min(1),
   enable_recurring: yup.string().required("Sass or E-commerce"),
});

export const campaignStepTwoSchema = yup.object().shape({
   commission_type: yup.string().required("Please select your preferred commission type!"),
   payout_terms: yup.string().required("Please select your preferred payout frequency!"),
   commission_percent: yup.number().min(1).max(99),
   commission_amount: yup.string(),
});
